import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import dateFormatter from '@sprinx/formatting/dateFormatter';
import FieldPreviewNaked from '../FieldPreviewNaked';
/**
 * @component
 */

function DateFieldPreviewNaked(props) {
  var defaultValue = props.defaultValue,
      value = props.value,
      rest = _objectWithoutProperties(props, ["defaultValue", "value"]);

  return /*#__PURE__*/React.createElement(FieldPreviewNaked, _extends({}, rest, {
    value: dateFormatter(value)
  }));
}

DateFieldPreviewNaked.propTypes = {
  align: PropTypes.oneOf(['inherit', 'left', 'center', 'right', 'justify']),
  className: PropTypes.string,

  /**
   * Barva zobrazovane hodnoty.
   */
  color: PropTypes.oneOf(['initial', 'error', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary']),

  /**
   * Hodnota pouzita pokud je `value` nedefinovane.
   */
  defaultValue: PropTypes.instanceOf(Date),
  display: PropTypes.oneOf(['initial', 'block', 'inline']),

  /**
   * `true` pokud se ma komponenta zobrazit v cele dostupne sirce.
   */
  fullWidth: PropTypes.bool,

  /**
   * Custom vlastnosti `Input`.
   */
  InputProps: PropTypes.shape({}),
  margin: PropTypes.oneOf(['none', 'dense', 'normal']),
  size: PropTypes.oneOf(['xsmall', 'small', 'normal', 'large', 'inherit']),
  style: PropTypes.shape({}),
  value: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string])
};
DateFieldPreviewNaked.defaultProps = {
  align: undefined,
  className: undefined,
  color: undefined,
  defaultValue: undefined,
  display: undefined,
  fullWidth: undefined,
  InputProps: undefined,
  margin: undefined,
  size: undefined,
  style: undefined,
  value: undefined
};
export default DateFieldPreviewNaked;